import React from 'react';
import { Table } from '@ajaibid/components';

import { styTable, styWrapper } from './style';
import useMfAutoOrder from './hooks/useMfAutoOrder';
import useColumns from './hooks/useColumns';
import PopupDelete from './components/PopupDelete';

const MutualFundsAutoOrder = () => {
  const { data, fetchNextPage, isInitialLoading, isFetchingNextPage } = useMfAutoOrder();
  const { id, index, columns, isModalDelete, setIsModalDelete, removeMfAutoOrder } = useColumns();

  return (
    <div className={styWrapper}>
      <Table
        className={styTable}
        data={data}
        columns={columns}
        options={{ isHeaderVisible: true }}
        fetchNext={fetchNextPage}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNextPage}
        emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
      />

      <PopupDelete
        id={id}
        index={index}
        data={data}
        isModalDelete={isModalDelete}
        setIsModalDelete={setIsModalDelete}
        removeMfAutoOrder={removeMfAutoOrder}
      />
    </div>
  );
};

export default MutualFundsAutoOrder;
